<div class="row align-items-center"
  style="border-bottom: 1px solid #5d2041; margin-top: 1px solid #5d2041; height:68.6px">
  <div class="col">
    <div class="eventsheader">Create Event</div>
  </div>
</div>

<div style="background-color: rgb(241, 235, 228); padding-bottom:10px">
  <form [formGroup]="eventForm" (ngSubmit)="addEvent()">
    <div class="container">
      <div class="row">
        <div class="col">

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Event Name*</mat-label>
              <input matInput formControlName="EventName">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Event Organizer</mat-label>
              <input matInput>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-checkbox [(ngModel)]="recurringEvent" class="example-margin" formControlName="isRecurring">Recurring
              Event</mat-checkbox>
          </div>

          <div class="row">
            <mat-form-field *ngIf="recurringEvent">
              <mat-label>Choose date range</mat-label>
              <mat-date-range-input [formGroup]="rangeDate" (focus)="picker.open()" [rangePicker]="picker">
                <input formControlName="start" matStartDate>
                <input formControlName="end" matEndDate>
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <mat-form-field class="datefield" *ngIf="!recurringEvent">
              <mat-label>Choose a date</mat-label>
              <input formControlName="date" matInput [matDatepicker]="picker" disabled>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker disabled="false" #picker></mat-datepicker>
            </mat-form-field>
            <!-- https://www.npmjs.com/package/ng2-timepicker -->
            <mat-form-field class="timefield" (click)="pickerTimeStart.open()">
              <mat-label>Start Time</mat-label>
              <input style="cursor: pointer;" placeholder="HH:MM" #starttime matInput [ngxTimepicker]="pickerTimeStart" 
                [format]="24" formControlName="start_time" />
            </mat-form-field>
            <ngx-material-timepicker [theme]="clockTheme" #pickerTimeStart #appendedToInput [appendToInput]="false"></ngx-material-timepicker>
            <mat-form-field class="timefield" (click)="pickerTimeEnd.open()">
              <mat-label>End Time</mat-label>
              <input style="cursor: pointer;" placeholder="HH:MM" #endtime matInput [ngxTimepicker]="pickerTimeEnd"
                [format]="24" formControlName="end_time" />
            </mat-form-field>
            <ngx-material-timepicker [theme]="clockTheme" #pickerTimeEnd #appendedToInput [appendToInput]="false"></ngx-material-timepicker>
          </div>

          <div class="row">
            <mat-card style="width: 100%;">
              <label>Category*</label>
              <br>
              <mat-chip-list #chipList [multiple]="true" [selectable]="true">
                <mat-chip *ngFor="let category of categories" #chip="matChip"
                  (click)="category.selected ? chip.deselect() : chip.selectViaInteraction()"
                  [selected]="category.selected" [selectable]="true" class="leadr-category-chip"
                  (selectionChange)="changeSelected($event, category)">
                  {{category.name}}
                </mat-chip>
              </mat-chip-list>
            </mat-card>
          </div>

          <div class="mapdiv">
            <div class="form-group">
              <label>Address*</label>
              <input (blur)="searchEnd()" formControlName="location" #search autocorrect="off" autocapitalize="off"
                spellcheck="off" type="text" class="form-control">
            </div>
            <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
              <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
                (dragEnd)="markerDragEnd($event)"></agm-marker>
            </agm-map>
            <input hidden [(ngModel)]="locationLat" formControlName="locationLat">Latitude: {{latitude}}<br>
            <input hidden [(ngModel)]="locationLng" formControlName="locationLng" value="">Longitude: {{longitude}}
          </div>

          <div class="row">
            <mat-card>
              <label>Fees</label><br>
              <mat-checkbox [ngModel]="eventFee" (change)="freeEventChange()">My Event is Free</mat-checkbox>
              <br>
              <label class="fixedpricehint">If your event is paid please provide the fees in the description
                below</label>
            </mat-card>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Website</mat-label>
              <input matInput formControlName="website">
            </mat-form-field>
          </div>

          <div class="row">
            <mat-label>Description*</mat-label><br>
            <!-- https://www.npmjs.com/package/ngx-quill -->
            <quill-editor style="background-color: white; border: 1px solid #5d2041;" [modules]="quillConfig" matInput
              formControlName="description" [styles]="{height: '250px'}"></quill-editor>
          </div>

          <div class="row">
            <div style="margin-top: 20px">
              <label (click)="fileInput.click()" class="uploadimagetext">Upload Image*</label>
              <br>
              <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" ng2FileSelect
                [uploader]="uploader" />
              <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
              <div (click)="fileInput.click()" class="imagecontainer">
                <img class="uploadedimage" [src]="url" *ngIf="url"></div>
              <div class="imagedescription">Supported formats (JPG, PNG, GIF, TIFF) with a maximum size of 5 MB</div>
            </div>
          </div>

        </div>

        <div class="col-md-5 col-md-offset-2">

          <!-- <div class="row">
          <mat-card style="width: 100%; margin-left: 10px; margin-top: 10px;">
            <label>Invite Co-Organizers</label>

            <form #addressForm="ngForm" class="container mt-3">
              some code here - see full code at the end of this tutorial
              <section *ngFor="let email of coOrganizers; let i = index;">
                input fields inside the *ngFor
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>E-mail</mat-label>
                  <input matInput type="text" [(ngModel)]="email.coOrganizers" name="email_{{i}}">
                </mat-form-field>

              </section>
            </form>
            <form>
              Add button
              <span style="color: #5d2041; cursor:pointer" (click)="addAddress()" class="material-icons">
                add_circle
              </span>
              ngFor code
            </form>
          </mat-card>
          </div> -->

          <div class="row">
            <h5 style="margin-top: 20px; margin-left: 10px;">Rules and Regulations:</h5>
            <ul>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut
              laoreet
              dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper
              suscipit lobortis nisl ut aliquip ex ea commodo consequat.</ul>
            <ul>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut
              laoreet
              dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper
              suscipit lobortis nisl ut aliquip ex ea commodo consequat.</ul>
            <ul>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut
              laoreet
              dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper
              suscipit lobortis nisl ut aliquip ex ea commodo consequat.</ul>
          </div>

        </div>

      </div>
    </div>

    <div class="row">
      <button class="submitbutton" type="submit">Submit Event Request</button>
    </div>

  </form>

  <mat-divider></mat-divider>

  <div style="display: flex; flex-wrap:wrap;">

    <div *ngFor="let item of adsListAdmin" class="advertisementcontainer">
      <div class="column">
        <div (click)="navigate(item.ads.url)"  class="sidecard ad">
          <img class="cardimg" src="{{'https://events.globalistic.tech/'+ item.ads.image}}" />
          <div class="sidecard-content ">
            <h1 class="title">{{item.ads.name}}</h1>
            <h2 class="sub_title">{{item.ads.description}}</h2>
            <p class="description">{{item.ads.url}}</p>
          </div>

        </div>
      </div>
    </div>
    <div *ngFor="let item of adsListUser" class="advertisementcontainer">
      <div class="column">
        <div (click)="navigate(item.link)" class="sidecard ad">
          <img class="cardimg" src="{{'https://events.globalistic.tech/'+ item.image}}" />
          <div class="sidecard-content ">
            <h1 class="title">{{item.name}}</h1>
            <h2 class="sub_title">{{item.description}}</h2>
            <p  class="description">{{item.link}}</p>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
